import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { EmployeeService } from '../../../core/services/employee/employee/employee.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import { HealthUnitService } from '../../../core/services/health-unit/location/health-unit.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {NgxMaskDirective} from 'ngx-mask';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {
  MunicipalityCentralService
} from '../../../core/services/municipality-central/municipality/municipality-central.service';

@Component({
  selector: 'municipality-central-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    MatSlideToggle,
    NgxMaskDirective,
  ],
  templateUrl: './municipality-central-create.component.html',
  styleUrl: './municipality-central-create.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    EmployeeService,
    HabitsService,
    AddressTypeService,
  ],
  standalone: true,
})
export class MunicipalityCentralCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private municipalityService: MunicipalityService,
    private municipalityCentralService: MunicipalityCentralService,
    private snackbar: SnackbarCustomService,
    private viaCepService: ViaCepService,
    private dialogRef: MatDialogRef<MunicipalityCentralCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() responseCreate = new EventEmitter()
  form: FormGroup = new FormGroup({})
  listMunicipios: any[] = []
  loading: boolean = false

  ngOnInit(): void {
    this.createForm()
    this.listMunicip()
  }
  listMunicip(){
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if(response.data){
          this.listMunicipios = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }
  close() {
    this.dialogRef.close()
  }

  createModel() {
    return {
      nome_fantasia: this.form.get('fantasy_name')?.value,
      razao_social: this.form.get('corporate_name')?.value,
      logradouro: this.form.get('street')?.value,
      municipio_id: this.form.get('municipality')?.value,
      email: this.form.get('email')?.value,
      senha: this.form.get('password')?.value,
      cnpj: this.form.get("cnpj")?.value,
      numero: this.form.get('number')?.value,
      telefone_1: '55'+this.form.get('phone_number')?.value,
      telefone_whatsapp: '55'+this.form.get('phone_number_whatsapp')?.value,
      cep: this.form.get('postal_code')?.value,
      bairro: this.form.get('neighborhood')?.value,
      cidade: this.listMunicipios.find(
        (item: any) => item.id === this.form.get('municipality')?.value
      )?.nome,
      estado: this.form.get('state')?.value,
      status_id: this.form.get('active')?.value === true ? 1 : 2,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      fantasy_name: ['', [Validators.required]],
      corporate_name: ['', [Validators.required]],
      street: ['', [Validators.required]],
      municipality: [null, [Validators.required]],
      number: ['', [Validators.required]],
      email: ['',[Validators.required]],
      phone_number: ['', [Validators.required]],
      phone_number_whatsapp: ['', [Validators.required]],
      password: ['',[Validators.required]],
      cnpj: ['',[Validators.required]],
      postal_code: ['', [Validators.required, Validators.minLength(8)]],
      city: [''],
      state: ['', [Validators.required]],
      neighborhood: ['', [Validators.required]],
      active: [true],
    })
  }
  getAddressByPostalCode() {
    let postalCode = this.form.get('postal_code')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
      })
    }
  }
  fillFormViaCep(element: any) {
    if (element.erro) {
    } else {
      this.form.get('street')?.setValue(element.logradouro)
      this.form.get('number')?.setValue('')
      this.form.get('neighborhood')?.setValue(element.bairro)
      this.form.get('city')?.setValue(element.localidade)
      this.form.get('state')?.setValue(element.estado)
    }
  }
  createLocation() {
    this.loading = true
    this.municipalityCentralService.createMunicipality(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
}
